import type { FC, ReactNode } from 'react';
import { DefaultLayout } from '@/base/layouts/DefaultLayout';

export const LandingLayout: FC<{
  children: ReactNode;
  hideFooter?: boolean;
}> = ({ children, hideFooter = false }) => {
  return <DefaultLayout hideFooter={hideFooter}>{children}</DefaultLayout>;
};
